import type { EvaluatedVideo, NodeId } from 'web';
import type { FlowGraph } from '../FlowGraph';

export class VideoView {
  constructor(
    private graph: FlowGraph,
    private id: NodeId,
    private index: number,
  ) {}

  setTime(time: number, ongoing: boolean) {
    this.graph.wasm.call((wasm) => {
      return wasm.setNodeVideoTime(this.id, this.index, time, ongoing);
    });
    if (!ongoing && this.graph.store.getNode(this.id).type === 'extract_video_frame') {
      this.graph.updateNodeOutputs(this.id);
    }
  }

  togglePlay() {
    // Resume the audio context under this user gesture. A no-op unless the audio
    // engine is active (its resources have been registered), so it never creates
    // a context when the audio-engine flag is off.
    this.graph.wasm.call((wasm) => wasm.resumeAudio());
    this.graph.wasm.call((wasm) => {
      return wasm.toggleNodeVideoPlay(this.id, this.index);
    });
    if (
      this.graph.getUIState().video[this.id]?.[this.index]?.paused &&
      this.graph.store.getNode(this.id).type === 'extract_video_frame'
    ) {
      this.graph.updateNodeOutputs(this.id);
    }
  }

  pauseIfPlaying() {
    const state = this.graph.getUIState().video[this.id]?.[this.index];
    if (state && !state.paused) {
      this.togglePlay();
    }
  }

  toggleMute() {
    this.graph.wasm.call((wasm) => {
      return wasm.toggleNodeVideoMute(this.id, this.index);
    });
  }

  evaluateVideo(): EvaluatedVideo | undefined {
    const value = this.graph.evaluateNode(this.id, this.index);
    if (value?.type !== 'video') {
      return undefined;
    }
    return value.value;
  }
}
